import React from 'react'
import Navbar from './Navbar'

function Blog() {

    return (
      <Navbar />
    )
  }
export default Blog